<div class="modal-heading">
  <div class="close-button invisible"></div>
  <div class="header-text">Filters</div>
  <div class="close-button" (click)="closeDialog()">
    <mat-icon class="close-icon">close</mat-icon>
  </div>
</div>
<div class="modal-body">
  <div class="filter-options">
    @for (item of filterOptions; track item.id; let i = $index) {
      <div
        [class]="
          i === selectedFilterIndex
            ? 'side-option-active'
            : 'side-option-inactive'
        "
        (click)="selectFilterItem(i)"
        (keydown.enter)="selectFilterItem(i)"
        tabindex="0"
      >
        <div
          [class]="
            i === selectedFilterIndex
              ? 'side-option-title-active'
              : 'side-option-title-inactive'
          "
        >
          {{ item.title }}
        </div>
      </div>
    }
  </div>
  <div class="filter-values" [formGroup]="filterForm">
    @switch (selectedFilterIndex) {
      @case (FILTERS.timeline) {
        <div style="display: flex; flex-direction: column; gap: 16px">
          <div class="form-container">
            <div class="form-label">From Date</div>
            <input
              type="date"
              class="dp-input-control search-input"
              formControlName="startDate"
              [max]="maxDate"
            />
          </div>
          <div class="form-container">
            <div class="form-label">To Date</div>
            <input
              type="date"
              class="dp-input-control search-input"
              formControlName="endDate"
              [max]="maxDate"
            />
          </div>
        </div>
      }
      @case (FILTERS.bankId) {
        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 16px;
            overflow-y: auto;
          "
        >
          @for (option of bankList; track option.id) {
            <div class="checkbox-container">
              <!-- <input
                type="checkbox"
                [value]="option.title"
                id="checkbx-{{ option.id }}"
                (change)="onCheckBank($event)"
                [checked]="selectedBank.includes(option.id)"
              />
              <label
                class="checkbox-label checkbox-inactive"
                for="checkbx-{{ option.id }}"
                >{{ option.title }}</label
              > -->
               <label class="custom-checkbox">
          <input type="checkbox" [value]="option.title" (change)="onCheckBank($event)" [checked]="selectedBank.includes(option.id)"/>
          <span class="checkmark"></span>
        </label>
        <label
                class="checkbox-label checkbox-inactive"
                for="checkbx-{{ option.id }}"
                >{{ option.title }}</label
              >
            </div>
          }
        </div>
      }
    }
  </div>
</div>
<div class="modal-footer">
  <button class="dp-secondary-btn" style="height: 4vh;" (click)="clearForm()">
    Clear filters
  </button>
  <button class="dp-primary-btn" style="height: 4vh;" (click)="applyFilter()">
    Apply filters
  </button>
</div>

